import { Add, DirectionsCar } from '@mui/icons-material';
import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Scrollbar } from 'react-scrollbars-custom';
import './AddCustomerModalV4.scrollbar.css';
import CarSvg from '../../utility/Svg/CarSvg';
import CustomerFleet from '../../utility/Svg/CustomerFleet';

// SVG Icons for Vehicle Details
const TrimIcon = ({ width = 20, height = 20 }) => (
    <div style={{ width: width, height: height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
            <path
                d="M19.0055 9.75828C18.4518 4.96928 15.2187 1.72443 10.2809 1.00537C9.96478 0.959378 9.68575 1.21515 9.68575 1.53457V5.08983C11.0351 5.21094 12.2821 5.79647 13.2542 6.76857C14.2263 7.74066 14.8118 8.9947 14.9329 10.3441H18.4741C18.7871 10.3441 19.0414 10.0692 19.0055 9.75828ZM11.4638 10.4263C11.2398 9.50416 10.4835 8.74787 9.56137 8.52384C7.60065 8.04752 5.86906 9.77904 6.34538 11.7398C6.56941 12.6619 7.3257 13.4183 8.24779 13.6422C10.2086 14.1185 11.9401 12.387 11.4638 10.4263ZM8.90462 12.6664C8.0315 12.6664 7.32123 11.9561 7.32123 11.083C7.32123 10.2099 8.0315 9.49962 8.90462 9.49962C9.77773 9.49962 10.488 10.2099 10.488 11.083C10.488 11.9561 9.77773 12.6664 8.90462 12.6664Z"
                fill="#006CDD"
            />
            <path
                d="M8.90279 10.5557C8.61159 10.5557 8.375 10.7923 8.375 11.0835C8.375 11.3747 8.61159 11.6113 8.90279 11.6113C9.194 11.6113 9.43059 11.3747 9.43059 11.0835C9.43059 10.7923 9.194 10.5557 8.90279 10.5557Z"
                fill="#006CDD"
            />
            <path
                d="M14.1756 11.6104C13.8794 11.6104 13.6602 11.3624 13.6592 11.0663C13.655 9.80593 13.1605 8.62012 12.266 7.72561C11.3715 6.8311 10.1857 6.33667 8.92537 6.33241C8.6292 6.33146 8.38128 6.11225 8.38128 5.81608V3.19238C4.17356 3.4718 0.85222 7.0437 0.99673 11.3532C1.13378 15.4404 4.55122 18.8579 8.63849 18.9949C12.948 19.1395 16.5198 15.8181 16.7993 11.6104H14.1756ZM4.80378 6.97727C5.0099 6.77115 5.34407 6.77115 5.55019 6.97727C5.75635 7.18339 5.75635 7.51755 5.55019 7.72368C5.34407 7.9298 5.0099 7.9298 4.80378 7.72368C4.59766 7.51755 4.5977 7.18339 4.80378 6.97727ZM3.63113 11.6104C3.33965 11.6104 3.10333 11.374 3.10333 11.0826C3.10333 10.791 3.33965 10.5548 3.63113 10.5548C3.92261 10.5548 4.15892 10.791 4.15892 11.0826C4.15892 11.374 3.92261 11.6104 3.63113 11.6104ZM5.55019 15.1879C5.34407 15.394 5.0099 15.394 4.80378 15.1879C4.59766 14.9817 4.59766 14.6475 4.80378 14.4414C5.0099 14.2353 5.34407 14.2353 5.55019 14.4414C5.75635 14.6475 5.75635 14.9817 5.55019 15.1879ZM8.90907 16.8883C8.61759 16.8883 8.38128 16.652 8.38128 16.3605C8.38128 16.069 8.61759 15.8327 8.90907 15.8327C9.20056 15.8327 9.43687 16.069 9.43687 16.3605C9.43687 16.652 9.20056 16.8883 8.90907 16.8883ZM9.6331 14.7078C7.03491 15.2044 4.78728 12.9567 5.28376 10.3585C5.55969 8.91452 6.74107 7.73321 8.18501 7.45728C10.7832 6.9608 13.0308 9.20843 12.5344 11.8066C12.2584 13.2506 11.0771 14.4318 9.6331 14.7078ZM13.0144 15.1879C12.8082 15.394 12.4741 15.394 12.268 15.1879C12.0618 14.9817 12.0618 14.6475 12.268 14.4414C12.4741 14.2353 12.8082 14.2353 13.0144 14.4414C13.2205 14.6475 13.2205 14.9817 13.0144 15.1879Z"
                fill="#006CDD"
            />
        </svg>
    </div>
);

const LicensePlateIcon = ({ width = 20, height = 20 }) => (
    <div style={{ width: width, height: height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
            <path
                d="M15.0933 10.396C15.2196 10.396 15.3253 10.3549 15.4107 10.2726C15.496 10.1903 15.5387 10.0883 15.5387 9.96657C15.5387 9.84486 15.496 9.74314 15.4107 9.66143C15.3253 9.57971 15.2199 9.53886 15.0942 9.53886H12.3591C12.2329 9.53886 12.1274 9.58 12.0427 9.66228C11.9579 9.74457 11.9153 9.84628 11.9147 9.96743C11.9141 10.0886 11.9567 10.1903 12.0427 10.2726C12.1286 10.3549 12.2341 10.396 12.3591 10.396H15.0933ZM15.0933 8.02171C15.2196 8.02171 15.3253 7.98057 15.4107 7.89829C15.496 7.81657 15.5387 7.71486 15.5387 7.59314C15.5387 7.47143 15.496 7.36971 15.4107 7.288C15.3253 7.20629 15.2199 7.16514 15.0942 7.16457H12.3591C12.2329 7.16457 12.1274 7.20571 12.0427 7.288C11.9579 7.37029 11.9153 7.47228 11.9147 7.594C11.9141 7.71571 11.9567 7.81743 12.0427 7.89914C12.1286 7.98086 12.2341 8.02171 12.3591 8.02171H15.0933ZM7.40178 11.1211C6.91407 11.1211 6.50104 11.1537 6.16267 11.2189C5.8237 11.284 5.52 11.3891 5.25156 11.5343C5.02044 11.6543 4.84593 11.7851 4.728 11.9269C4.61007 12.0686 4.55141 12.2209 4.552 12.3837C4.552 12.5123 4.60593 12.6197 4.71378 12.706C4.82104 12.7917 4.95259 12.8346 5.10845 12.8346H9.704C9.85926 12.8346 9.98933 12.7877 10.0942 12.694C10.1991 12.6003 10.2516 12.488 10.2516 12.3571C10.2516 12.2131 10.1956 12.0737 10.0836 11.9389C9.97156 11.804 9.79437 11.6691 9.552 11.5343C9.28296 11.3891 8.97926 11.284 8.64089 11.2189C8.30252 11.1537 7.88948 11.1211 7.40178 11.1211ZM7.40178 9.736C7.77689 9.736 8.09274 9.61228 8.34933 9.36486C8.60652 9.11686 8.73511 8.812 8.73511 8.45028C8.73511 8.08857 8.60652 7.784 8.34933 7.53657C8.09215 7.28914 7.7763 7.16514 7.40178 7.16457C7.02726 7.164 6.71141 7.288 6.45422 7.53657C6.19704 7.78514 6.06845 8.08971 6.06845 8.45028C6.06845 8.81086 6.19704 9.11571 6.45422 9.36486C6.71141 9.614 7.02726 9.73771 7.40178 9.736ZM3.43644 16C3.02696 16 2.68533 15.868 2.41156 15.604C2.13778 15.34 2.00059 15.0103 2 14.6149V5.38514C2 4.99029 2.13719 4.66086 2.41156 4.39686C2.68593 4.13286 3.02726 4.00057 3.43556 4H16.5644C16.9733 4 17.3147 4.13229 17.5884 4.39686C17.8622 4.66143 17.9994 4.99086 18 5.38514V14.6157C18 15.01 17.8628 15.3394 17.5884 15.604C17.3141 15.8686 16.9727 16.0006 16.5644 16H3.43644Z"
                fill="#006CDD"
            />
        </svg>
    </div>
);

const VINIcon = ({ width = 20, height = 20 }) => (
    <div style={{ width: width, height: height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
            <path
                d="M2 15V5H3.45455V15H2ZM4.18182 15V5H5.63636V15H4.18182ZM6.36364 15V5H7.09091V15H6.36364ZM8.54545 15V5H10V15H8.54545ZM10.7273 15V5H12.9091V15H10.7273ZM13.6364 15V5H14.3636V15H13.6364ZM15.8182 15V5H18V15H15.8182Z"
                fill="#006CDD"
            />
        </svg>
    </div>
);

// Reusable Vehicle Card Component
const VehicleCard = ({ watchIsFleetCustomer, vehicle, onEdit, onDelete, isSelected, onSelect }) => {
    const vehicleName =
        `${vehicle.year || vehicle?.vehicleYear || ''} ${vehicle.make || ''} ${vehicle.model || ''} ${vehicle.trim || ''} ${vehicle.vehicleModelTrim?.name ? ' ' + vehicle.vehicleModelTrim?.name : ''}`.trim();
    const licenseDisplay =
        vehicle.licenseNumber || vehicle?.license
            ? `${vehicle.provinceCode || vehicle.province?.provinceCode || ''} ${vehicle.licenseNumber || vehicle?.license || ''}`.trim()
            : '-';
    const trimDisplay = vehicle.vehicleModelTrim?.description || '-';
    const vinDisplay = vehicle.vin || '-';
    const fleetDisplay = vehicle.fleetUnitNumber || '-';

    const handleCardClick = (e) => {
        // Prevent selection when clicking on edit/delete buttons
        if (e.target.closest('svg') || e.target.closest('.action-button')) {
            return;
        }
        if (onSelect) {
            onSelect(vehicle._id);
        }
    };

    return (
        <div
            onClick={handleCardClick}
            style={{
                padding: '16px',
                border: isSelected ? '2px solid #006CDD' : '1px solid rgba(0, 0, 0, 0.10)',
                borderRadius: '8px',
                position: 'relative',
                boxShadow: isSelected ? '0 2px 2px 0 rgba(0, 0, 0, 0.10)' : 'none',
                background: isSelected ? '#F0F7FF' : '#fff',
                cursor: 'pointer',
                transition: 'all 0.2s ease-in-out',
            }}
        >
            <Stack spacing="8px">
                {/* First Line: Car Icon + Vehicle Name (Left) | Edit/Delete (Right) */}
                <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ height: '22px!important' }}>
                    <Box display="flex" gap="8px" alignItems="center">
                        <CarSvg width={20} height={20} />
                        <Typography
                            variant="subtitle1"
                            fontWeight={500}
                            sx={{ fontSize: '16px', lineHeight: '120%', letterSpacing: '0.15px', color: 'rgba(0, 0, 0, 0.87)' }}
                        >
                            {vehicleName}
                        </Typography>
                    </Box>
                    <Box display="flex" gap="8px" alignItems="center">
                        <Box
                            className="action-button"
                            sx={{ cursor: 'pointer', display: 'flex' }}
                            onClick={(e) => {
                                e.stopPropagation();
                                onEdit(vehicle);
                            }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M3 21V16.75L16.2 3.575C16.4 3.39167 16.621 3.25 16.863 3.15C17.105 3.05 17.359 3 17.625 3C17.891 3 18.1493 3.05 18.4 3.15C18.6507 3.25 18.8673 3.4 19.05 3.6L20.425 5C20.625 5.18333 20.771 5.4 20.863 5.65C20.955 5.9 21.0007 6.15 21 6.4C21 6.66667 20.9543 6.921 20.863 7.163C20.7717 7.405 20.6257 7.62567 20.425 7.825L7.25 21H3ZM17.6 7.8L19 6.4L17.6 5L16.2 6.4L17.6 7.8Z"
                                    fill="black"
                                    fill-opacity="0.6"
                                />
                            </svg>
                        </Box>
                        <Box
                            className="action-button"
                            sx={{ cursor: 'pointer', display: 'flex' }}
                            onClick={(e) => {
                                e.stopPropagation();
                                onDelete(vehicle);
                            }}
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_21729_216270)">
                                    <path d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4Z" fill="#D32F2F" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_21729_216270">
                                        <rect width="24" height="24" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </Box>
                    </Box>
                </Box>

                {/* Vertical List of Details */}
                {trimDisplay !== '-' && (
                    <Box display="flex" gap="8px" alignItems="center">
                        <TrimIcon />
                        <Typography variant="body2" sx={{ fontSize: '16px', color: '#000', fontWeight: 400 }}>
                            {trimDisplay}
                        </Typography>
                    </Box>
                )}

                {vinDisplay !== '-' && (
                    <Box display="flex" gap="8px" alignItems="center">
                        <VINIcon />
                        <Typography variant="body2" sx={{ fontSize: '16px', color: '#000', fontWeight: 400 }}>
                            {vinDisplay}
                        </Typography>
                    </Box>
                )}

                {licenseDisplay !== '-' && (
                    <Box display="flex" gap="8px" alignItems="center">
                        <LicensePlateIcon />
                        <Typography variant="body2" sx={{ fontSize: '16px', color: '#000', fontWeight: 400 }}>
                            {licenseDisplay}
                        </Typography>
                    </Box>
                )}

                {watchIsFleetCustomer && fleetDisplay !== '-' && (
                    <Box display="flex" gap="8px" alignItems="center">
                        <CustomerFleet />
                        <Typography variant="body2" sx={{ fontSize: '16px', color: '#000', fontWeight: 400 }}>
                            {fleetDisplay}
                        </Typography>
                    </Box>
                )}
            </Stack>
        </div>
    );
};

const VehicleSelectionForm = ({
    watch,
    isRecordFoundIsShopImported = false,
    isLoading,
    vehicles,
    onAddVehicle,
    onEditVehicle,
    onDeleteVehicle,
    onSelectVehicle,
    customerId,
    selectedVehicleId,
}) => {
    const [selectedId, setSelectedId] = useState(selectedVehicleId || null);
    const watchIsFleetCustomer = watch('isFleetCustomer');

    // Update selectedId when selectedVehicleId prop changes
    useEffect(() => {
        if (selectedVehicleId !== undefined) {
            setSelectedId(selectedVehicleId);
        }
    }, [selectedVehicleId]);

    const handleVehicleSelect = (vehicleId) => {
        setSelectedId(vehicleId);
        if (onSelectVehicle) {
            onSelectVehicle(vehicleId);
        }
    };

    return (
        <Box sx={{ width: '100%' }}>
            {!isRecordFoundIsShopImported && (
                <Box display="flex" justifyContent="flex-end" alignItems="center" mb={3}>
                    <Button variant="contained" color="secondary" startIcon={<Add />} onClick={onAddVehicle}>
                        ADD VEHICLE
                    </Button>
                </Box>
            )}

            <Scrollbar trackXVisible={false} disableTrackYWidthCompensation style={{ width: '100%', height: '400px' }} className="AddCustomerModalV4-scrollbar">
                <Box sx={{ pr: 2, boxSizing: 'border-box' }}>
                    {isLoading ? (
                        <CircularProgress />
                    ) : vehicles && vehicles.length > 0 ? (
                        <Stack spacing={2}>
                            {vehicles.map((vehicle) => (
                                <VehicleCard
                                    watchIsFleetCustomer={watchIsFleetCustomer}
                                    key={vehicle._id}
                                    vehicle={{
                                        ...vehicle,
                                        make: vehicle.vehicleMake?.name || vehicle.make,
                                        model: vehicle.vehicleModel?.name || vehicle.model,
                                        provinceCode: vehicle.province?.code,
                                    }}
                                    onEdit={onEditVehicle}
                                    onDelete={onDeleteVehicle}
                                    isSelected={selectedId === vehicle._id}
                                    onSelect={handleVehicleSelect}
                                />
                            ))}
                        </Stack>
                    ) : (
                        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" py={4} sx={{ color: 'text.secondary' }}>
                            <DirectionsCar sx={{ fontSize: 48, mb: 1, opacity: 0.5 }} />
                            <Typography variant="body1">No vehicles found for this customer.</Typography>
                            {/* <Typography variant="body2">Click ADD VEHICLE to add a new one.</Typography> */}
                        </Box>
                    )}
                </Box>
            </Scrollbar>
        </Box>
    );
};

export default VehicleSelectionForm;
